import React, { useRef, useEffect } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "../ui/card";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";
import { Pencil, Trash2 } from "lucide-react";

const StockCards = ({
    items,
    loading = false,
    selectedItems = new Set(),
    selectionMode = false,
    toggleSelection,
    onEdit,
    onDeleteRequest,
    onEnterSelectionMode
}) => {
    const timerRef = useRef(null);

    const startLongPress = (symbol) => {
        timerRef.current = setTimeout(() => {
            if (onEnterSelectionMode) {
                onEnterSelectionMode();
            }
            toggleSelection(symbol);
            timerRef.current = null;
        }, 600);
    };

    const cancelLongPress = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };

    // Mitigation pour T-04-05 : nettoyage du timer au démontage
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    if (!loading && items.length === 0) {
        return null;
    }

    return (
        <div className="grid grid-cols-1 gap-4 md:hidden">
            {loading ? (
                Array.from({ length: 3 }).map((_, i) => (
                    <Card key={`skeleton-${i}`}>
                        <CardContent>
                            <Skeleton className="h-6 w-3/4 mb-2" />
                            <Skeleton className="h-4 w-1/2" />
                        </CardContent>
                    </Card>
                ))
            ) : (
                items.map((item) => (
                    <Card
                        key={item.stock_symbol}
                        className="relative transition-all duration-200"
                        onMouseDown={() => startLongPress(item.stock_symbol)}
                        onMouseUp={cancelLongPress}
                        onMouseLeave={cancelLongPress}
                        onTouchStart={() => startLongPress(item.stock_symbol)}
                        onTouchEnd={cancelLongPress}
                        onTouchCancel={cancelLongPress}
                        onClick={() => {
                            if (selectionMode) {
                                toggleSelection(item.stock_symbol);
                            }
                        }}
                    >
                        {selectionMode && (
                            <div className="absolute top-2 left-2 z-10">
                                <input
                                    type="checkbox"
                                    checked={selectedItems.has(item.stock_symbol)}
                                    onChange={() => toggleSelection(item.stock_symbol)}
                                    className="h-4 w-4 rounded border-gray-300"
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </div>
                        )}
                        <CardHeader>
                            <CardTitle className="text-lg font-bold">{item.stock_symbol}</CardTitle>
                            <CardDescription>{item.company_name}</CardDescription>
                        </CardHeader>
                        <CardFooter className="flex justify-end gap-2">
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={(e) => { e.stopPropagation(); onEdit(item); }}
                            >
                                <Pencil className="h-4 w-4 mr-1" />
                                Modifier
                            </Button>
                            <Button
                                variant="ghost"
                                size="sm"
                                className="text-destructive hover:text-destructive hover:bg-destructive/10"
                                onClick={(e) => { e.stopPropagation(); onDeleteRequest(item.stock_symbol); }}
                            >
                                <Trash2 className="h-4 w-4 mr-1" />
                                Supprimer
                            </Button>
                        </CardFooter>
                    </Card>
                ))
            )}
        </div>
    );
};

export default StockCards;
